import { useFeatureValue } from '@growthbook/growthbook-react';
import { useUserType } from './useUserType';
import { GrowthBookFeature } from '../model/experiment';

/**
 * This hook is used to check if the user is in the PayShip experiment for the buyer scenario(eg. VIP, SRP, HeaderMenu, etc.).
 * Seller scenario(eg. SYI, My Ads, etc.) should use GrowthBookFeature.PAY_SHIP_SELLER
 */
export function useShowPayShipFeature() {
    try {
        const inExperiment_PAY_SHIP_BUYER =
            useFeatureValue(GrowthBookFeature.PAY_SHIP_BUYER, 'A') === 'B';
        const userType = useUserType();

        return userType === 'STANDARD' && inExperiment_PAY_SHIP_BUYER;
    } catch (_) {
        return false;
    }
}
